import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import styles from './group.scss.js';
let counter = 0;
/**
 * @element cipublic-group
 */
export class Group extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * ID to associate the label with the element.
         */
        this._id = ++counter;
        /**
         * Constructor name.
         */
        this._name = 'group';
        /**
         * The group type.
         */
        this.variant = 'group';
        this.emitConnectedCallback = false;
    }
    static get styles() {
        return [styles];
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.emitConnectedCallback) {
            emit(this, 'connected-callback');
        }
    }
    renderGroup(idName) {
        return html `<div role="group" aria-describedby="${idName}"><slot id="${idName}" name="label"></slot><div class="parent"><slot></slot></div></div>`;
    }
    renderNavigation(idName) {
        return html `<slot id="${idName}" name="label"></slot><nav aria-describedby="${idName}"><slot name="content"></slot></nav>`;
    }
    render() {
        const idName = `${this._name}-${this._id}`;
        return this.variant === 'navigation' ? this.renderNavigation(idName) : this.renderGroup(idName);
    }
}
__decorate([
    property({ reflect: true })
], Group.prototype, "variant", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], Group.prototype, "emitConnectedCallback", void 0);
//# sourceMappingURL=group.js.map